import { ECode } from "~/_enums/ECode";
import * as Sentry from "@sentry/react";
import { ERROR_UNKNOWN } from "~/_constants/errors";
import { TDao } from "~/_types/TDao";
import { fetchGetJson } from "~/_libs/fetch/fetchGetJson";
import { TApiConfig } from "~/_libs/fetch/fetchConfig";

type TGetDaoInput = { daoId: string };

export type TGetDaoOutput = {
  code: typeof ECode.Success;
  data: TDao;
};

/** 커뮤니티 정보 조회 */
export const getDao = (params: TGetDaoInput, config: TApiConfig) => {
  const { daoId } = params;

  return fetchGetJson<TGetDaoOutput>(`/daos/${daoId}`, {}, config).then(
    (result) => {
      switch (result.code) {
        case ECode.Success:
          return result;
        default:
          Sentry.captureException(ERROR_UNKNOWN, {
            extra: {
              apiName: "getDao",
              payload: params,
              res: result,
            },
          });

          throw new Error(ERROR_UNKNOWN);
      }
    },
  );
};
